export default "__VITE_ASSET__cQ6Ua$B3__"